import gql from 'graphql-tag';

export const GET_HEADER_DATA = gql`
    query HeaderData{ 
        NotApprovedProductReviewsCount
    }
`;
